import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, InputBox, SelectInputBox } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import TextEditor from '../CommonComponents/TextEditor';

const EmailTemplateMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        serviceProvider: '',
        productFamilyCode: '',
        docType: '',
        emailSubject: '',
        mailFormat:''
    });
    const GetServiceProviderData = DropDownData('')
    const GetDocTypeData = DropDownData('')

    const getEmailTemplateMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(``, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            serviceProvider: '',
            productFamilyCode: '',
            docType: '',
            emailSubject: '',
            mailFormat: ''
        });
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(``, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(``, { serviceProviderID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(``, { serviceProviderID: id }, getEmailTemplateMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getEmailTemplateMasterData(value);
    };

    useEffect(() => {
        getEmailTemplateMasterData()
        document.title = 'Email Template Master'
        inputrefs.current['txtServiceProvider'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Email Template Master'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <SelectInputBox
                                id="txtServiceProvider"
                                value={formData.serviceProvider}
                                label='Service Provider'
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                required={true}
                                onChange={(e) => setFormData({ ...formData, serviceProvider: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtProductFamilyCode'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetServiceProviderData?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <AutoCompleteBoxNew
                                id="txtProductFamilyCode"
                                placeholder="Product Family"
                                label={'Product Family'}
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                required={true}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDocType'].focus()
                                    }
                                }}
                                autocompleteType='GetProductFamily'
                                value={formData.productFamilyCode || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, productFamilyCode: newInputValue })
                                    }
                                }}
                                maxLength='50'
                            />
                            <SelectInputBox
                                id="txtDocType"
                                value={formData.docType}
                                label='Doc Type'
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                required={true}
                                onChange={(e) => setFormData({ ...formData, docType: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailSubject'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetDocTypeData?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <InputBox
                                id="txtEmailSubject"
                                type="text"
                                label='Email Subject'
                                required={true}
                                placeholder="Email Subject"
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                maxLength='100'
                                value={formData.emailSubject}
                                onChange={(e) => setFormData({ ...formData, emailSubject: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                            />

                        </div>
                        <TextEditor
                            label="Mail Format"
                            id='txtMailFormat'
                            value={formData.mailFormat}
                            onChange={(e) => setFormData({ ...formData, mailFormat: e })}

                        />
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(``, filterData, 'Email Template Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'EmailTemplateMaster'}
                handleFilter={() => {
                    getEmailTemplateMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default EmailTemplateMaster;

